var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,5.8c5.5,0,9.9,4.4,9.9,9.9s-4.4,9.9-9.9,9.9s-9.9-4.4-9.9-9.9S10.5,5.8,16,5.8z M16,4.4 c6.3,0,11.3,5.1,11.3,11.3S22.3,27.1,16,27.1S4.7,22,4.7,15.7S9.7,4.4,16,4.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.7,13.5c0.3,0.2,0.8,0.1,1-0.3c0.9-1.5,2.5-2.5,4.3-2.5c1.8,0,3.4,1,4.3,2.5c0.2,0.3,0.6,0.5,1,0.3 c0.3-0.2,0.4-0.6,0.3-1c-1.1-2-3.2-3.2-5.5-3.2c-2.3,0-4.4,1.2-5.5,3.2C10.3,12.9,10.4,13.3,10.7,13.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.6,17.8c0-1.2-0.6-2.1-1.4-2.1c-0.8,0-1.4,1-1.4,2.1s0.6,2.1,1.4,2.1C13.9,20,14.6,19,14.6,17.8z M20.2,17.8 c0-1.2-0.6-2.1-1.4-2.1c-0.8,0-1.4,1-1.4,2.1s0.6,2.1,1.4,2.1C19.6,20,20.2,19,20.2,17.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.6b1510d08b0c24aa4df29ecb61c7ef4b.svg";
export { ForwardRef as ReactComponent };